import { Alert, Card, CardContent, CardHeader, Grid } from "@mui/material";
import React from "react";
import BarChartCustom from "../shared/chart/BarChartCustom";
import BarChartStackedCustom from "../shared/chart/BarChartStackedCustom";
import LineChartCustom from "../shared/chart/LineChartCustom";
import PieChartCustom from "../shared/chart/PieChartCustom";
import LoadingWrapper from "../shared/loading";
import Stat from "../shared/stat";
import EnhancedTable from "../shared/table";

const DashboardBlocksRenderer = ({
  blockList = [],
  loading,
  cartTitle = "custom-cards",
}) => {
  const onRenderDashboardBlock = (item) => {
    switch (item.blockType) {
      case "Box":
        return (
          <Stat
            type={item?.boxData?.color}
            value={item?.boxData?.value}
            unit=""
            label={item?.boxData?.title}
            date={item?.boxData?.lastUpdate}
            dateLabel="آخرین بروزرسانی"
            isTime={false}
            hasShowMore={true}
            showMore={{
              link: item?.boxData?.link || "",
              text: "اطلاعات بیشتر",
            }}
          />
        );

      case "Table":
        const table = item.tableData;

        const tableColumns = table.columns.map((x) => ({
          id: x,
          label: x,
        }));
        const tableData = table.data.map((row, index) => {
          let item = {};

          for (let i = 0; i < row.length; i++) {
            item[table.columns[i]] = row[i];
          }
          return item;
        });

        return (
          <Card className="dashboard-block-item">
            <CardHeader title={item?.tableData?.title} />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <EnhancedTable
                    rowKey={"id"}
                    rows={tableData}
                    headCells={tableColumns}
                    pageSize={100}
                    showFilter={false}
                    showIndex={false}
                    showPaging={false}
                    isDashboard={true}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );

      case "Chart":
        const chartData = item?.chartData;
        let data = [];

        data = chartData.xValues.map((item) => ({ x: item }));

        for (let i = 0; i < chartData.data.length; i++) {
          const yData = chartData.data[i];
          const sereTitle = chartData.seriesTitle[i];

          for (let j = 0; j < yData.length; j++) {
            data[j][sereTitle] = yData[j];
          }
        }

        let output = <Alert severity="warning">این نوع چارت وجود ندارد!</Alert>;
        // console.log(chartData.seriesColor);
        switch (chartData.chartType) {
          case "Line":
            output = (
              <LineChartCustom
                // title={chartData.title}
                xAxisTitle={chartData.xAxisTitle}
                yAxisTitle={chartData.yAxisTitle}
                data={data}
                series={chartData.seriesTitle}
                showZoomOutButton={true}
                colors={chartData.seriesColor}
                fill={chartData?.fill || false}
                opacity={chartData?.opacity || 0.4}
                multiScale={chartData?.multiScale || null}
                pointStyle={chartData?.pointStyle || null}
                customTooltips={chartData?.x2Values || null}
                isDashboardView={true}
                yAxisMax={chartData?.yAxisMax || null}
                yAxisMin={chartData?.yAxisMin || null}
              />
            );
            break;

          case "Pie":
            const pie = chartData.seriesTitle
              .map((ser) => ({
                name: ser,
                value: parseFloat(
                  data
                    .reduce((total, obj) => (total += obj[ser]), 0)

                    .toFixed(2)
                ),
              }))
              .filter((x) => x.value >= 0);

            output = (
              <PieChartCustom
                // title={chartData.title}
                data={pie}
                colors={chartData.seriesColor}
              />
            );
            break;
          case "Column":
            output = (
              <BarChartCustom
                // title={chartData.title}
                xAxisTitle={chartData.xAxisTitle}
                yAxisTitle={chartData.yAxisTitle}
                data={data}
                series={chartData.seriesTitle}
                showZoomOutButton={true}
                colors={chartData.seriesColor}
                customTooltips={chartData?.x2Values || null}
                yAxisMax={chartData?.yAxisMax || null}
                yAxisMin={chartData?.yAxisMin || null}
              />
            );
            break;

          case "StackedColumn":
            output = (
              <BarChartStackedCustom
                // title={chartData.title}
                xAxisTitle={chartData.xAxisTitle}
                yAxisTitle={chartData.yAxisTitle}
                data={data}
                series={chartData.seriesTitle}
                colors={chartData.seriesColor}
                showZoomOutButton={true}
                customTooltips={chartData?.x2Values || null}
                yAxisMax={chartData?.yAxisMax || null}
                yAxisMin={chartData?.yAxisMin || null}
              />
            );
            break;

          default:
            break;
        }

        return (
          <Card className="dashboard-block-item">
            <CardHeader title={item?.chartData?.title} />
            <CardContent style={{ padding: 0, paddingBottom: 0 }}>
              {output}
            </CardContent>
          </Card>
        );

      default:
        return null;
    }
  };

  if (loading) {
    return (
      <Grid item xs={12} md={12}>
        <LoadingWrapper />
      </Grid>
    );
  }

  return Array.isArray(blockList) && blockList.length > 0
    ? blockList
        .sort((a, b) => a.priority - b.priority)
        .map((item, index) => (
          <Grid
            item
            key={`${cartTitle}-${index}`}
            xs={item.xs}
            sm={item.sm}
            md={item.md}
            lg={item.lg}
          >
            {onRenderDashboardBlock(item)}
          </Grid>
        ))
    : null;
};

export default DashboardBlocksRenderer;
